import { useEffect } from 'react';

const useOpenGraph = ({ title, description, image }) => {
  useEffect(() => {
    // Store original meta tags
    const originalMeta = {};
    ['og:title', 'og:description', 'og:image'].forEach(property => {
      const tag = document.querySelector(`meta[property="${property}"]`);
      if (tag) originalMeta[property] = tag.content;
    });

    // Set new meta tags
    const metaTags = {
      'og:title': title ? `${title} | WP-Autoplugin` : 'WP-Autoplugin — Agentic coding, inside WordPress',
      'og:description': description || 'An agentic coding environment purpose-built for WordPress.',
      ...(image ? { 'og:image': image } : {}),
    };

    Object.entries(metaTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });

    // Cleanup function
    return () => {
      Object.entries(originalMeta).forEach(([property, content]) => {
        const tag = document.querySelector(`meta[property="${property}"]`);
        if (tag) tag.setAttribute('content', content);
      });
    };
  }, [title, description, image]);
};

export default useOpenGraph;
